import { ADD_SQUARE, REMOVE_SQUARE, SELECT_SQUARE, REPLACE_SQUARE, ALTER_SQUARE, TOGGLE_DEATH, ADD_STAR, POP_STAR, COMBINE_STARS, SELECT_TOOL, ADD_SET, SET_SQUARES } from '../actions/types';
import { createSquare, createEmptySquare } from '../utilities';


const INITIAL = {};

export default function(state = INITIAL, action) {

  switch(action.type) {
    case SET_SQUARES :
      return action.payload;
    case ADD_SET : {
      return Object.keys(state).reduce( (newState, square_id) => {
        let square = state[square_id];
        if (square.deadCount) {
          square = {...square, deadCount : square.deadCount - 1}
          if (square.deadCount === 0) {
            delete square.deadCount;
            square.dead = false;
          }
        }
        newState[square_id] = square;
        return newState;
      }, {});
    }
    case SELECT_SQUARE : {
      if (!state[action.payload]) { return state };
      let newState = {...state};
      let square = newState[action.payload] = {...newState[action.payload]};
      square.selected = !square.selected;
      return newState;
    }
    case TOGGLE_DEATH : {
      let newState = {...state};
      const square_id = action.payload.id;
      let square = newState[square_id] = {...newState[square_id]};
      square.dead = !square.dead;
      if (square.dead) {
        square.deadCount = action.payload.deadCount;
      }

      return newState;
    }
    case ADD_STAR : {

      if (!state[action.payload.id]) { return state };

      let newState = {...state};
      const square_id = action.payload.id;
      newState[square_id] = {...newState[square_id], star : true, empty : false};

      return newState;

    }
    case POP_STAR : {

      if (!state[action.payload.id]) { return state };

      let newState = {...state};
      const square_id = action.payload.id;
      newState[square_id] = {...newState[square_id], star : false, empty : false};

      return newState;

    }
    case COMBINE_STARS : {

      const square_id = action.payload;
      const square = state[square_id];

      let starSquares = [];
      let siblings = [];
      Object.values(state).forEach( sq => {
        if (sq.star && sq.depth === square.depth) {
          starSquares.push(sq);
        }
        if (sq.parent_id === square.parent_id) {
          siblings.push(sq);
        }
      });

      if (starSquares.length < 8) {
        return state;
      }

      let newState = {...state};

      // okay. Now the fun. If we've got more than 8 stars at this depth, we're going to re-arrange them and combine into a bigger star for bonus points

      starSquares = starSquares.filter( sq => sq.parent_id !== square.parent_id);

      siblings.forEach( sib => {

        if (!sib.star) {
          let star = starSquares.shift();
          star = newState[star.id] = {...star};
          delete star.star;

          [star.animal, star.direction, star.fill, star.dead, star.deadCount] = [sib.animal, sib.direction, sib.fill, star.dead, star.deadCount];
          //need to iterate through the sib to find all kids and re-assign them to now have the star as their parent. Tedious.
          Object.values(newState).forEach( sq => {
            if (sq.parent_id === sib.id) {
              newState[sq.id] = {...sq, parent_id : star.id};
            }
          })
        }

        delete newState[sib.id];
      });

      newState[square.parent_id] = { ...newState[square.parent_id], star : true };

      return newState;
    }
    case SELECT_TOOL : {
      return Object.keys(state).reduce( (newState, square_id) => {
        let square = state[square_id];
        if (square.selected === true) {
          square = {...square, selected : false};
        }
        newState[square_id] = square;
        return newState;
      }, {})
    }
    case REPLACE_SQUARE : {
      let newState = {...state};
      newState[action.payload.id] = action.payload;
      return newState;
    }
    case ALTER_SQUARE : {
      let newState   = { ...state };

      let target;
      if (action.payload.target_id) {
        target = newState[action.payload.target_id] = { ...newState[action.payload.target_id] };
      }
      const source   = newState[action.payload.source_id];
      const tool     = action.payload.tool;

      if (tool.value !== undefined || tool.tool === 'alarm') {
        target = newState[action.payload.source_id] = {...newState[action.payload.source_id]};

        // if we're altering with a value, we're in the editor (or it's an alarm, but ignore that for now)
        // and a missing direction is not obvious, since it just looks like they're facing right. So explicitly
        // set direction to faction right (1).
        if (target.direction === undefined) {
          target.direction = 1;
        }
        if (tool.tool !== 'expand') {
          delete target.empty;
        }
        delete target.star;
        // I Freaking HATE special cases.
        if (tool.tool === 'alarm') {
          if (target.dead) {
            target.dead = false;
            delete target.deadCount;
          }
          else {
            return state;
          }
        }
        else if (tool.tool === 'eraser') {
          target.empty = true;
          delete target.fill;
          delete target.animal;
          delete target.direction;
          delete target.selected;
        }
        else if (tool.tool === 'star') {
          target.star = true;
        }
        else if (tool.tool === 'lock') {
          target.locked = !target.locked;
        }
        else if (tool.tool === 'expand' && target.depth < 3 && !target.locked) {
          let nextsquare_id = Math.max(...Object.keys(newState)) + 1;
          for (let idx = 0; idx < 8; idx++) {
            const square_id = nextsquare_id + idx;
            newState[square_id] = createEmptySquare({square_id, parent_id : target.id, idx, depth : target.depth + 1});
          };
        }
        else if (tool.tool === 'collapse' && target.depth > 1) {
          const parent_id = target.parent_id;
          Object.keys(newState).forEach( square_id => {
            if (newState[square_id].parent_id === parent_id) {
              delete newState[square_id];
            };
          });
          newState[parent_id] = {...newState[parent_id], empty : true};
        }
        else {
          target[tool.field] = tool.value;
        }
      }
      else {
        target[tool.field] = source[tool.field];
      }

      return newState;

    }
    case ADD_SQUARE : {
      let newState = {...state};
      let leveldef = action.payload.leveldef || {};

      let nextsquare_id = Math.max(...Object.keys(newState), (leveldef.maxsquare_id || 0)) + 1;

      let parent = newState[action.payload.parent_id];

      if (parent.locked) {
        newState[action.payload.parent_id] = {...parent, empty : true};
      }
      else if (leveldef.children[action.payload.parent_id]) {
        leveldef.children[action.payload.parent_id].forEach(square => newState[square.id] = square);
      }
      else {
        for (let idx = 0; idx < 8; idx++) {
          const square_id = nextsquare_id + idx;

          newState[square_id] = createSquare(
            {
              square_id,
              parent_id : parent.id,
              idx,
              depth : parent.depth + 1,
              leveldefs : leveldef
            }
          );
        };
      }

      return newState;

    }
    case REMOVE_SQUARE : {

      return Object.keys(state).reduce( (acc, square_id) => {
        if (state[square_id].parent_id !== action.payload) {
          acc[square_id] = state[square_id];
        }
        return acc;
      }, {});

    }
    default :
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/squares_reducer.js